<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.73432 7.17182C6.80078 9.49219 4.86719 11.8125 4.86719 11.8125L8.73433 16.4532"
      stroke="#6E6055"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="20"
      y="13"
      width="15"
      height="2"
      transform="rotate(-180 20 13)"
      fill="#6E6055"
    />
  </svg>
</template>
